const initialState = {
  data: null,
  isError: false,
  isSuccess: false,
  isLoading: false,
  isEdit: false,
  isDelete: false,
  isCreate: false,
  message: "",
};

export const loadingHandler = (state) => {
  state.isLoading = true;
};

export const fulfilledHandler = (state, action, options = {}) => {
  state.isLoading = false;
  state.isSuccess = true;
  state.data = action.payload;

  Object.assign(state, {
    isEdit: options.isEdit,
    isCreate: options.isCreate,
    isDelete: options.isDelete,
  });
};

export const fulfilledHandlerIdle = (state, action) => {
  state.isLoading = false;
  state.message = action.payload;
};

export const rejectedHandler = (state, action) => {
  state.isLoading = false;
  state.isError = true;
  state.message = action.payload;
};

export default initialState;
